import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-8 lg:gap-10">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
              <i className="ri-question-line" />
              FAQ
            </span>
            <h2 className="mt-3 font-heading font-black text-3xl md:text-4xl text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              关于入口、防走失和内容来源，被问得最多的几个问题都放在这里了。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                  >
                    <span className="font-heading font-bold text-base md:text-lg text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                        open
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}